import React from 'react';
import { Menu } from 'semantic-ui-react';
import styled from 'styled-components';

import { Admin } from '@/types/admin';
import { Organization } from '@/types/organization';
import { FormatError } from '@/services/api';
import { getFullName } from '@/utils/name';
import { LoginMenuContainer } from '../Container/LoginMenuContainer';
import { AnnouncementContainer } from '../Container/AnnouncementContainer';
import { LogoContents } from './LogoContents';

export type Props = {
  me: Admin;
  currentOrganization: Organization;
  isLoggedIn: boolean;
  unreadCount: number;
  markArticlesAsRead: () => void;
  error: FormatError<any>;
  language: string;
};

export const AppHeader: React.FC<Props> = ({
  me,
  currentOrganization,
  isLoggedIn,
  unreadCount,
  markArticlesAsRead,
  error,
  language,
}) => (
  <Wrapper>
    <StyledMenu borderless={true} fixed="top">
      <LogoContents language={language} />
      <Menu.Menu position="right">
        {isLoggedIn && (
          <AdminInfo text={true}>
            <AdminItem>{currentOrganization.corporationOfficialName}</AdminItem>
            <AdminItem>
              {currentOrganization.gloplaId
                ? `[${currentOrganization.gloplaId}]`
                : ''}
            </AdminItem>
            <AdminItem>{getFullName(me.firstName, me.lastName)}</AdminItem>
          </AdminInfo>
        )}
        <AnnouncementContainer
          unreadCount={unreadCount}
          markArticlesAsRead={markArticlesAsRead}
        />
        {isLoggedIn && (
          <LoginMenuContainer error={error} isLoggedIn={isLoggedIn} />
        )}
      </Menu.Menu>
    </StyledMenu>
  </Wrapper>
);

const Wrapper = styled.header`
  & + * {
    margin-top: 56px;
  }
`;

const StyledMenu = styled(Menu)`
  && {
    border: none;
    border-radius: unset;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  }
`;

const AdminItem = styled(Menu.Item)`
  &&&& {
    color: rgba(51, 51, 51, 0.6);
  }
`;

const AdminInfo = styled(Menu)`
  &&& {
    margin: 0;
    padding-right: 24px;
  }
`;
